const common = {
  siteName: "17c com一起草在线",
  siteDescription: "免费在线视频播放平台",
  home: "首页",
  category: "分类",
  about: "关于我们",
  allCategories: "全部分类",
  hotRecommend: "热门推荐",
  latestUpdate: "最新更新",
  featuredTopics: "特色专题",
  viewMore: "查看更多",
  play: "播放",
  relatedVideos: "相关推荐",
  comments: "评论",
  share: "分享",
  contactUs: "联系我们",
  brandIntro: "品牌介绍",
  reputation: "口碑评价",
  companyName: "17c com一起草在线视频平台",
  copyright: "© 2026 17c com一起草在线 版权所有",
  breadcrumbHome: "首页",
  scrollToTop: "回到顶部",
  search: "搜索",
  searchPlaceholder: "搜索你喜欢的视频...",
  noResults: "暂无相关内容",
  loading: "加载中...",
  readMore: "阅读更多",
  publishedOn: "发布于",
  views: "次播放",
  duration: "时长",
  episode: "集",
  score: "评分",
  submit: "提交",
  reset: "重置",
  name: "姓名",
  email: "邮箱",
  message: "留言",
  phone: "电话",
  address: "地址",
  followUs: "关注我们",
  privacyPolicy: "隐私政策",
  termsOfService: "服务条款",
  faq: "常见问题",
  sitemap: "网站地图",
};

export default common;